 (function () {
    async function insertSectionCartDrawer() {
      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper')
      if (!wrapper) {
        wrapper = document.createElement('div')
        wrapper.classList.add('cart-drawer-items-wrapper')
        cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
        wrapper.appendChild(cartDrawerItems)
      }

      var prevUpsell = wrapper.querySelector('#cart-drawer-upsell')
      if (prevUpsell) prevUpsell.remove()

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      if (upsells) wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('#CartDrawer .cart-drawer-upsell-list li')) {
        var upsellEl = wrapper.querySelector('#cart-drawer-upsell')
        if (upsellEl) upsellEl.remove()
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()
      }
    }
    insertSectionCartPage() */

    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return

      let timer

      const observeOptions = { attributes: true, childList: true, subtree: true }

      const observer = new MutationObserver((mutations) => {
        // Don't rebuild while the shopper is using the upsell variant <select>: replacing
        // the DOM would destroy the open native dropdown and snap it shut immediately.
        const active = document.activeElement
        if (active && active.tagName === 'SELECT' && active.closest('#cart-drawer-upsell')) return

        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          // Stop observing before we mutate below, otherwise our own DOM writes retrigger
          // this observer in an endless refetch/rebuild loop (~every 450ms).
          observer.disconnect()
          try {
            const respoonse = await fetch(window.location.href)
            const text = await respoonse.text()
            const newDocument = new DOMParser().parseFromString(text, 'text/html')

            const existingWrapper = document.querySelector('#cart-drawer-upsell-wrapper')
            const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper')
            if (existingWrapper && newWrapper) existingWrapper.replaceWith(newWrapper)

            insertSectionCartDrawer()
          } finally {
            observer.observe(element, observeOptions)
          }
        }, 250)
      })

      observer.observe(element, observeOptions);
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer

      const observeOptions = { attributes: true, childList: true, subtree: true }

      const observer = new MutationObserver((mutations) => {
        // Don't rebuild while the shopper is using the upsell variant <select> (same reason
        // as the cart drawer: it would close the open native dropdown).
        const active = document.activeElement
        if (active && active.tagName === 'SELECT' && active.closest('#cart-drawer-upsell')) return

        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          // Disconnect before mutating so our own DOM writes don't retrigger the observer forever.
          observer.disconnect()
          try {
            const respoonse = await fetch(window.location.href)
            const text = await respoonse.text()
            const newDocument = new DOMParser().parseFromString(text, 'text/html')

            const existingWrapper = document.querySelector('#cart-drawer-upsell-wrapper')
            const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper')
            if (existingWrapper && newWrapper) existingWrapper.replaceWith(newWrapper)
          } finally {
            observer.observe(element, observeOptions)
          }
        }, 250)
      })

      observer.observe(element, observeOptions);
    }
    listenCartPage()
  })();